module.exports = __webpack_public_path__ + "static/media/MenuIcon.1f50ee80.svg";